import React, { useState } from 'react'

import { AppWrap, MotionWrap  } from '../../wrapper';
import './Footer.scss';

export const Footer = () => {
  const [formData, setFormData] = useState({ username: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setIsFormSubmitted(false);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      return;
    }

    setLoading(true);
    setSubmitError('');

    const encodedForm = new URLSearchParams();
    new FormData(event.currentTarget).forEach((value, key) => {
      encodedForm.append(key, value);
    });

    try {
      const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
      const submissionUrl = isLocal
        ? `${window.location.protocol}//${window.location.hostname}:3000/.netlify/functions/submit-contact`
        : '/.netlify/functions/submit-contact';
      const response = await fetch(submissionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encodedForm.toString(),
      });

      if (!response.ok) {
        throw new Error(`Contact submission returned ${response.status}`);
      }

      setFormData({ username: '', email: '', message: '' });
      setIsFormSubmitted(true);
    } catch (err) {
      console.error('Unable to submit contact form:', err);
      setSubmitError('Your message could not be sent. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className="head-text">Chat with me</h2>

      <form
        className="app__footer-form app__flex"
        name="contact"
        method="POST"
        onSubmit={handleSubmit}
      >
          <p className="app__footer-honeypot" aria-hidden="true">
            <label>
              Do not fill this out if you are human:
              <input name="bot-field" tabIndex="-1" autoComplete="off" />
            </label>
          </p>
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} required maxLength="100" />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} required maxLength="254" />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
              required
              maxLength="5000"
            />
          </div>
          {submitError && (
            <p className="app__footer-error p-text" role="alert">
              {submitError}
            </p>
          )}
          <button type="submit" className="p-text" disabled={loading}>
            {!loading ? 'Send Message' : 'Sending...'}
          </button>
          {isFormSubmitted && (
            <p className="app__footer-success p-text" role="status">
              Thank you. Your message has been received.
            </p>
          )}
      </form>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
